// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__MRxz-","requiredAsterisk":"Info_requiredAsterisk__yo2g9"};